module.exports = __webpack_public_path__ + "static/media/garbageTruck_black.7458e318.svg";